import {
  Directive,
  ElementRef,
  Input,
  AfterViewInit,
  OnDestroy,
  Renderer2
} from '@angular/core';
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { LayoutService } from '@services/layout.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appPreloader]'
})
export class PreloaderDirective implements AfterViewInit, OnDestroy {
  subscription: Subscription;

  constructor(
    private el: ElementRef,
    router: Router,
    layoutService: LayoutService,
    private renderer: Renderer2
  ) {
    console.log('PreloaderDirective constructor hit!');

    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });

    this.subscription = layoutService.preloaderState$.subscribe(state => {
      this.updatePreloader(state);
    });
  }

  ngAfterViewInit() {}

  active() {
    if (this.el.nativeElement) {
      this.renderer.removeAttribute(this.el.nativeElement, 'hidden');
    }
  }

  hide() {
    if (this.el.nativeElement) {
      this.renderer.setAttribute(this.el.nativeElement, 'hidden', 'hidden');
    }
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.active();
    }
    if (event instanceof NavigationEnd) {
      this.hide();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.hide();
    }
    if (event instanceof NavigationError) {
      this.hide();
    }
  }

  //
  updatePreloader(state) {
    // console.log('change state')
    if (state === 'active') {
      this.active();
    }

    if (state === 'hide') {
      this.hide();
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.unsubscribe();
  }
}
